<mat-form-field *ngIf="isCargoOwner" class="property" appearance="standard">
  <mat-label>{{title}}<span class="asterisk">*</span></mat-label>
  <input matInput [matAutocomplete]="autocompleteCompanies" [placeholder]="title" [formControl]="companySelectCtrl">
  <mat-autocomplete #autocompleteCompanies="matAutocomplete" [displayWith]="displayCompanyName"
    (optionSelected)="onSelectCompany($event)">
    <mat-option *ngFor="let company of listCompaniesAsync | async" [value]="company"
      [disabled]="isCompanyInactive(company)" [matTooltip]="getTooltip(company)" matTooltipClass="tooltip__error"
      matTooltipPosition="right">
      <span>{{company.name}}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<!-- Third Parties -->

<mat-form-field class="property" appearance="standard"
  *ngIf="!isCargoOwner && manualCreationCargoService.getCargoForm().get('ministry').value && !isInternational">
  <mat-label>{{title}}<span class="asterisk">*</span></mat-label>
  <input (keyup)="selectionChange()" matInput [matAutocomplete]="autocompleteThirdParties" [placeholder]="title"
    [formControl]="thirdPartySelectCtrl">
  <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingThirdParties">
    <span class="sr-only">Loading...</span>
  </div>
  <mat-autocomplete #autocompleteThirdParties="matAutocomplete" [displayWith]="displayThirdPartyName"
    (optionSelected)="onSelectThirdParty($event)">
    <mat-option [value]="null" *ngIf="!isInternational &&hasPermissionToCreateThirdParties">
      <span class="font-italic">Agregar {{title}} (Crear en el RNDC)</span>
    </mat-option>
    <mat-option *ngFor="let thirdParty of listThirdPartiesAsync | async" [value]="thirdParty">
      <span>{{thirdParty.name}}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<mat-form-field class="property" appearance="standard" *ngIf="(showAddressField && !isInternational)">
  <mat-label>{{isCargoOwner? 'Sede central' : 'Dirección'}}<span class="asterisk">*</span></mat-label>
  <input (keyup)="addressChange()" matInput [matAutocomplete]="autocompleteAddress" placeholder="Direcciones"
    [formControl]="inputFormControl.get('address')">
  <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingAddresses">
    <span class="sr-only">Loading...</span>
  </div>
  <mat-autocomplete #autocompleteAddress="matAutocomplete" [displayWith]="displayAddressName"
    (optionSelected)="onSelectAddress($event)">
    <mat-option [value]="null" *ngIf="hasPermissionToCreateThirdPartyAddress">
      <span class="font-italic">
        Agregar {{title === 'Remitente'? 'Sitio de cargue' : title === 'Destinatario'? 'Sitio de descargue' :
        'dirección'}}
      </span>
    </mat-option>
    <mat-option *ngFor="let address of listAddressesAsync | async" [value]="address"
      [disabled]="utils.disableThirdPartyAddress(address).disable"
      [matTooltip]="utils.disableThirdPartyAddress(address).reason" matTooltipClass="tooltip__error">
      <span>{{address?.branchOfficeName? address?.branchOfficeName : address?.address?.address}}</span>
    </mat-option>
  </mat-autocomplete>

  <mat-hint
    *ngIf="!isCargoOwner && inputFormControl?.get('address')?.value && inputFormControl?.get('id')?.value && !inputFormControl.get('location')?.value?.lat && !inputFormControl.get('location')?.value?.lng"
    class="color-secondary-dark text-bold">La dirección seleccionada requiere <u class="cursor-pointer"
      (click)="openAddLatLng()">asociar longitud y latitud</u></mat-hint>
  <mat-hint
    *ngIf="!isCargoOwner && inputFormControl?.get('address')?.value && inputFormControl?.get('id')?.value && inputFormControl.get('location')?.value?.lat && inputFormControl.get('location')?.value?.lng"
    class="color-secondary-dark text-bold cursor-pointer" (click)="editThirdPartyAddressDialog()">
    <i class="fas fa-edit"></i> Editar dirección
  </mat-hint>
</mat-form-field>

<!-- Verificación geo de la dirección seleccionada -->
<app-geo-validation-feedback
  [validating]="addressGeoValidating"
  [error]="addressGeoError"
  [showEditButton]="!!manualCreationCargoService.getCargoForm().get('ministry').value"
  (editAddress)="editThirdPartyAddressDialog()">
</app-geo-validation-feedback>

<!-- Address and New Address -->
<div class="property" *ngIf="!manualCreationCargoService.getCargoForm().get('ministry').value || isInternational">
  <app-autocomplete-city
    *ngIf="!cityNewAddress && isCargoOwner && manualCreationCargoService.getCargoForm().get('ministry').value"
    [options]="optionsCity" [inputFormControl]="cityControl"></app-autocomplete-city>
  <app-autocomplete-address *ngIf="((cityNewAddress || !isCargoOwner) &&
    manualCreationCargoService.getCargoForm().get('ministry').value)
    || (!manualCreationCargoService.getCargoForm().get('ministry').value && !isCargoOwner)" [options]="{
      title: 'Dirección',
      initialValue: inputFormControl?.get('address')?.value,
      internationalCode: options?.code,
      municipalityCode: cityNewAddress || options?.city?.municipalityCode,
      showHintRequiredAddressSelection: true,
      selectAddressOnMap: true,
      selectFromExternalMap: true
  }" [inputFormControl]="addressControl">
  </app-autocomplete-address>
  <span class="pattern pattern--invalid"
    *ngIf="inputFormControl.get('address').errors && inputFormControl.get('address').errors.addressEqualCity">
    La Dirección no puede ser la misma que la Ciudad
  </span>
</div>